<!doctype html>
<html lang="en">
  <head>
    <meta charset="utf-8" />
    <meta name="viewport" content="width=device-width, initial-scale=1.0" />
    <meta name="description" content="Hologram Dashboard" />
    <meta name="author" content="Hologram" />
    <meta name="keywords" content="Hologram, Dashboard, IoT, Telemetry, Data, Analytics" />

    <title>Hologram Dashboard</title>

    <!-- Google Tag Manager -->
    <script>
      (function (w, d, s, l, i) {
        w[l] = w[l] || [];
        w[l].push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });
        var f = d.getElementsByTagName(s)[0],
          j = d.createElement(s),
          dl = l != 'dataLayer' ? '&l=' + l : '';
        j.async = true;
        j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
        f.parentNode.insertBefore(j, f);
      })(window, document, 'script', 'dataLayer', 'GTM-W2N88L2');
    </script>
    <!-- End Google Tag Manager -->

    <link rel="icon" href="/assets/img/favicons/favicon.png" sizes="32x32" />
    <link rel="icon" href="/assets/img/favicons/icon.svg" type="image/svg+xml" />
    <link rel="apple-touch-icon" href="/assets/img/favicons/apple-touch-icon.png" />
    <link rel="manifest" href="/assets/img/favicons/manifest.webmanifest" />
    <meta name="theme-color" media="(prefers-color-scheme: light)" content="#F8F8FA" />
    <meta name="theme-color" media="(prefers-color-scheme: dark)" content="#00040F" />
  </head>

  <body>
    <!-- Google Tag Manager (noscript) -->
    <noscript
      ><iframe
        src="https://www.googletagmanager.com/ns.html?id=GTM-W2N88L2"
        height="0"
        width="0"
        style="display: none; visibility: hidden"
      ></iframe
    ></noscript>
    <!-- End Google Tag Manager (noscript) -->

    <!-- Bundled application -->
    <script type="module" src="/src/js/index.tsx"></script>

    <div id="root"></div>
  </body>
</html>
